import React from 'react';
import PropTypes from 'prop-types';
import { Modal, List } from 'semantic-ui-react';

import styles from './UnclosedTasksModal.module.scss';

const UnclosedTasksModal = React.memo(({ open, unclosedTasks, onClose, onCardClick }) => {
  const handleTaskClick = (cardId) => {
    if (onCardClick) {
      onCardClick(cardId);
    }
    onClose();
  };

  return (
    <Modal
      open={open}
      closeIcon
      size="small"
      centered={false}
      className={styles.modal}
      onClose={onClose}
    >
      <Modal.Header>Незакрытые задачи</Modal.Header>
      <Modal.Content className={styles.content}>
        {!unclosedTasks || unclosedTasks.length === 0 ? (
          <div className={styles.emptyMessage}>Нет незакрытых задач</div>
        ) : (
          <List divided relaxed>
            {unclosedTasks.map((task) => (
              <List.Item key={task.cardId} className={styles.taskItem}>
                <List.Content>
                  <List.Header
                    as="a"
                    className={styles.taskLink}
                    onClick={() => handleTaskClick(task.cardId)}
                  >
                    {task.cardName}
                  </List.Header>
                </List.Content>
              </List.Item>
            ))}
          </List>
        )}
      </Modal.Content>
    </Modal>
  );
});

UnclosedTasksModal.propTypes = {
  open: PropTypes.bool.isRequired,
  /* eslint-disable react/forbid-prop-types */
  unclosedTasks: PropTypes.array,
  /* eslint-enable react/forbid-prop-types */
  onClose: PropTypes.func.isRequired,
  onCardClick: PropTypes.func.isRequired,
};

UnclosedTasksModal.defaultProps = {
  unclosedTasks: [],
};

export default UnclosedTasksModal;
